import { writable } from 'svelte/store';
import MediaService from '@/services/media';
import { FontFamilies, TextAnimations } from '@/types/metadata';
const mediaService = new MediaService();
const initialMetaDataState = {};
const { subscribe, update } = writable(initialMetaDataState);
const actions = {
    getTextAnimations: async () => {
        const items = TextAnimations.map((item, i) => {
            return {
                id: i + 1,
                label: item,
                value: item
            };
        });
        update(mt => {
            return {
                ...mt,
                textAnimations: items
            };
        });
    },
    setFonts: (fonts) => {
        update(store => ({ ...store, fonts }));
    },
    getFonts: async () => {
        const items = FontFamilies.map((item, i) => {
            return {
                id: i + 1,
                label: item,
                value: item
            };
        });
        update(mt => {
            return {
                ...mt,
                fonts: items
            };
        });
    },
    getMusic: async () => {
        const response = await mediaService.fetchAll();
        const items = response.map((item, i) => {
            return {
                id: i + 1,
                label: item.name,
                value: item.url
            };
        });
        update(mt => {
            return {
                ...mt,
                music: items
            };
        });
    }
};
const metadata = {
    subscribe,
    ...actions
};
export default metadata;
